module.exports = __webpack_public_path__ + "static/img/发展历史背景@2x.8394b08.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/发展历史背景@2x.png
// module id = ELBO
// module chunks = 0